(ns shared.core.timer
  (:require [shared.core.reactive :as re]
            [shared.core.time :as t]
            [shared.core.util :as util]))

(def root-path (util/ns->keyword-path ::root))
(def timers-path (conj root-path :timers))

(defn set-timer [db timer-kind timer-id time-in-ms func]
  (assoc-in db (conj timers-path timer-kind timer-id) (js/setTimeout func time-in-ms)))

(defn timer [db timer-kind timer-id]
  (get-in db (conj timers-path timer-kind timer-id)))

(defn all-timers-by-kind [db timer-kind]
  (get-in db (conj timers-path timer-kind)))

(defn clear-timeout [timeout]
  (when timeout
    (try
      (js/clearTimeout timeout)
      (catch :default _))))

(defn clear-timeout-by-key [db timer-kind timer-id]
  (clear-timeout (timer db timer-kind timer-id)))

(defn clear-timer [db timer-kind timer-id]
  (clear-timeout-by-key db timer-kind timer-id)
  (update-in db (conj timers-path timer-kind) dissoc timer-id))

(defn time->time-in-ms [time]
  (if (fn? time)
    (time)
    (condp = time
      :one-day t/one-day
      :one-hour t/one-hour
      :one-minute t/one-minute
      :one-second t/one-second
      time)))

(re/reg-event-db
  :timer/set-timer re/quiet-middleware
  (fn [db [timer-kind timer-id time func {:keys [fire-first? repeat? extra-on-fail] :as args}]]
    (if (and timer-kind timer-id time func)
      (let [time-in-ms (time->time-in-ms time)
            try-func (fn [] (try
                              (func)
                              (catch :default ex
                                (do
                                  (when extra-on-fail
                                    (extra-on-fail ex))
                                  (js/console.warn "Timer call failed")))))]
        (clear-timeout-by-key db timer-kind timer-id)
        (when fire-first? (try-func))
        (set-timer db timer-kind timer-id time-in-ms
                   (if repeat?
                     #(do
                        (re/dispatch [:timer/set-timer timer-kind timer-id time func (dissoc args :fire-first?)])
                        (try-func))
                     try-func)))
      db)))

(re/reg-event-db
  :timer/clear-timer re/middleware
  (fn [db [timer-kind timer-id]]
    (clear-timer db timer-kind timer-id)))

(re/reg-event-db
  :timer/clear-timers-by-kind re/middleware
  (fn [db [timer-kind]]
    (doall
      (for [[_ timeout] (get-in db (conj timers-path timer-kind))]
        (clear-timeout timeout)))
    (update-in db timers-path dissoc timer-kind)))

(re/reg-event-db
  :timer/clear-all-timers re/middleware
  (fn [db]
    (let [all-timeouts (some->> (get-in db timers-path)
                                (map (fn [[_ timers]]
                                       (map second timers)))
                                (flatten))]
      (doall
        (for [timeout all-timeouts]
          (clear-timeout timeout)))
      (update-in db root-path dissoc :timers))))

(re/reg-event-db
  :timer/store-minutes-to-hour re/quiet-middleware
  (fn [db]
    (assoc-in db (conj root-path :minutes-to-hour) (t/minutes-to-next-hour))))

(defn timer-minutes-to-hour [db]
  (or (get-in db (conj root-path :minutes-to-hour))
      (do
        (re/dispatch [:timer/set-timer :time-to :minutes-to-hour (fn [] (* (t/seconds-to-next-minute) 1000))
                      (fn [] (re/dispatch [:timer/store-minutes-to-hour]))
                      {:repeat? true
                       :fire-first? true}])
        (t/minutes-to-next-hour))))

(re/reg-sub :timer/minutes-to-hour- timer-minutes-to-hour)

(re/reg-event-db
  :timer/store-seconds-to-minute re/quiet-middleware
  (fn [db]
    (assoc-in db (conj root-path :seconds-to-minute) (t/seconds-to-next-minute))))

(defn timer-seconds-to-minute [db]
  (or (get-in db (conj root-path :seconds-to-minute))
      (do
        (re/dispatch [:timer/set-timer :time-to :seconds-to-minute 1000
                      (fn [] (re/dispatch [:timer/store-seconds-to-minute]))
                      {:repeat? true
                       :fire-first? true}])
        (t/seconds-to-next-minute))))

(re/reg-sub :timer/seconds-to-minute- timer-seconds-to-minute)
